import request from '@/utils/request'

export function list(query) {
  return request({
    url: '/sys/menu/list',
    method: 'get',
    params: query
  })
}

export function info(id) {
  return request({
    url: '/sys/menu/info/' + id,
    method: 'get'
  })
}

export function save(data) {
  return request({
    url: '/sys/menu/save',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/sys/menu/update',
    method: 'post',
    data
  })
}

export function remove(data) {
  return request({
    url: '/sys/menu/delete',
    method: 'post',
    data
  })
}

export function getPerms() {
  return request({
    url: '/sys/menu/perms',
    method: 'get'
  })
}

